<template>
  <div class="overflow-y-auto max-h-full pr-4 -mr-4">
    <Question
      v-for="question in questions"
      :key="question.id"
      :question="question"
    />

    <div
      v-if="questions.length === 0"
      class="text-base-0 text-center mt-8"
    >
      <h3 class="text-md14-h18 font-semibold">
        {{ $t(emptyText.title) }}
      </h3>
      <p class="text-md14-h18 text-base-30 font-normal mt-3">
        {{ $t(emptyText.description) }}
      </p>
    </div>
  </div>
</template>

<script>
import Question from '@/components/question-moderation/Question.vue'

// containers
import QuestionContainer from '@/containers/question-moderation/Question.ts'

export default {
  components: {
    Question: QuestionContainer(Question),
  },
  props: {
    selectedStatus: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // Keys match the presenter app's translated empty-state strings so each
    // status reuses the existing 32-language translations.
    emptyText() {
      const map = {
        pending: {
          title: 'No questions to review right now',
          description: 'You’ll see new questions here as the audience submits them.',
        },
        approved: {
          title: 'No questions have been approved',
          description: 'Approved questions will appear here and be visible to the audience.',
        },
        dismissed: {
          title: 'No questions have been dismissed',
          description: 'Dismissed questions will show here for your reference.',
        },
      }
      return map[this.selectedStatus] || map.pending
    },
  },
}
</script>
